<template>
  <v-card density="compact" flat height="90vh" width="100%" class="d-flex flex-column live-board-root">
    <CommonBoardHeader
      boardName="Account Live Board"
      :existFilterData="existFilterData"
      :workSpaceName="backupTableData"
      @search-data="getSearch"
      @applyChange="applyChange"
      @export-data="exportFile"
      @show-zero-issue="getSwitchData"
      @scroll="scrollToPosition"
      style="flex-shrink: 0;"
    />

    <!-- Linear progress bar beneath header during data fetching -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      height="3"
      style="flex-shrink: 0;"
    ></v-progress-linear>

    <v-card-text class="flex-grow-1 pa-0 overflow-hidden position-relative">
      <!-- Full spinner loader when initial loading or when no data is loaded yet -->
      <div
        v-if="loading && (!tableData || tableData.length === 0)"
        class="d-flex flex-column align-center justify-center"
        style="height: 60vh;"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="52"
          width="4"
        ></v-progress-circular>
        <span class="mt-4 text-grey-darken-2" style="font-size: 15px; font-weight: 500;">
          Loading Account Live Board...
        </span>
        <span class="text-caption text-grey mt-1">
          Fetching workspaces and accounts data
        </span>
      </div>

      <!-- Empty state when not loading and no data found -->
      <div
        v-else-if="!loading && (!tableData || tableData.length === 0)"
        class="d-flex flex-column align-center justify-center"
        style="height: 50vh;"
      >
        <v-icon size="48" color="grey-lighten-1">mdi-clipboard-text-off-outline</v-icon>
        <span class="mt-3 text-grey-darken-1" style="font-size: 15px; font-weight: 500;">
          No accounts found
        </span>
        <span class="text-caption text-grey mt-1">
          Try clearing filters or adjusting your search
        </span>
      </div>

      <!-- Main Live Table Container -->
      <div
        v-else
        class="table-scroll-container"
        :style="{ opacity: loading ? 0.6 : 1, transition: 'opacity 0.2s ease' }"
        style="width: 100%; height: 100%; overflow: auto;"
      >
        <LiveTable
          :tableData="tableData"
          :allData="ProductionData"
          @printData="addData"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LiveTable from "./LiveTable.vue";
import ProductionDashboardService from "@/api/service/ProductionDashboard/ProductionDashboard";
import ExportService from "@/ExportService";
import IssueService from "@/api/service/Issue/IssueService";
import CommonBoardHeader from "../LiveBoardEmployee/CommonBoardHeader.vue";
import moment from "moment";

export default {
  components: {
    LiveTable,
    CommonBoardHeader,
  },

  data() {
    return {
      existFilterData: null,
      menu: false,
      loading: true,
      downloadMenu: ["Excel", "Pdf", "Json"],
      ProductionData: [],
      search: null,
      searchClicked: false,
      tableData: [],
      finalExportData: [],
      backupTableData: [],
      isDrawer: false,
      switchBtn: "OFF",
      workTimingId: null,
      fixedIndex: null,
    };
  },

  async created() {
    let saved = localStorage.getItem("filterData");
    let filterObj = null;
    if (saved && saved !== "undefined" && saved !== "null") {
      try {
        filterObj = JSON.parse(saved);
        this.existFilterData = filterObj;
      } catch (e) {
        this.existFilterData = null;
      }
    }
    await this.getProductionData(filterObj);
    this.finalExportData = this.tableData;
  },
  computed: {
    isDrawerOpen() {
      return this.$store.getters.getIssueViewDrawer;
    },
    isIssueChanged() {
      return this.$store.getters.getDefaultIssueInView;
    },
  },
  watch: {
    isIssueChanged() {
      this.showIssueView = true;
    },
  },
  methods: {
    moment,
    applyChange($event) {
      this.fixedIndex = null;
      this.existFilterData = $event || null;
      this.getProductionData($event);
    },
    scrollToPosition(index) {
      if (index === null || index === undefined) {
        this.fixedIndex = null;
        this.tableData = [...this.backupTableData];
        return;
      }
      this.fixedIndex = index;
      if (this.backupTableData && this.backupTableData[this.fixedIndex]) {
        this.tableData = [JSON.parse(JSON.stringify(this.backupTableData[this.fixedIndex]))];
      }
    },
    async getFilterData(data) {
      this.filterData = data;
      this.filterDialog = false;
      this.getissuetype(this.filterData);
      this.menu = false;
    },
    async getissuetype($obj) {
      let obj = {};
      if ($obj) {
        obj = $obj;
      }
      obj.next_action = this.userId;
      var res = await IssueService.getAssignToMeData(obj);
      this.issueType = res && res.length ? res : [];
    },
    getSwitchData($event) {
      if ($event) {
        let switchData = [];
        for (let item of this.backupTableData) {
          let $accountData = [];
          for (let item1 of item.accountData) {
            if (item1.total_issues === 0) {
              $accountData.push(item1);
            }
          }
          if ($accountData.length > 0) {
            let data = JSON.parse(JSON.stringify(item));
            data.accountData = $accountData;
            switchData.push(data);
          }
        }
        this.tableData = switchData;
      } else {
        if (this.fixedIndex !== null && this.backupTableData[this.fixedIndex]) {
          this.tableData = [JSON.parse(JSON.stringify(this.backupTableData[this.fixedIndex]))];
        } else {
          this.tableData = JSON.parse(JSON.stringify(this.backupTableData));
        }
      }
    },
    goIssueView(item) {
      let status = this.$store.getters.getMyspace;

      localStorage.setItem(
        "_WS_DEFAULTS_",
        JSON.stringify({
          workspace: { id: item.work_space_id, name: item.work_space_name },
        })
      );
      localStorage.setItem("workSpaceId", item.work_space_id);

      // this.$router.push({ path: "/issueView2", query: { id: item.id } });
      this.$store.dispatch("setIssueInView", item.id);
      let wsDefaults = {
        workspace: { id: item.work_space_id, name: item.work_space_name },
        user: { id: item.user_id, name: item.user_name },
        project: { id: item.project_id, name: item.project_name },
      };
      let wsDefaultsData = JSON.stringify(wsDefaults);
      localStorage.setItem("_WS_DEFAULTS_", wsDefaultsData);
      this.$store.commit("SET_REFRESH_BREADCRUMP", true);
      this.$store.commit("CHANGE_MY_SPACE", !status);
    },
    toggleSearch() {
      this.searchClicked = !this.searchClicked;
      if (this.searchClicked) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      const textField = this.$refs.searchContainer;
      if (textField && !textField.contains(event.target)) {
        this.searchClicked = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    getSearch($event) {
      let searchData = [];
      if ($event && $event.trim()) {
        let q = $event.toLowerCase().trim();
        for (let item of this.backupTableData) {
          let $accountData = [];
          for (let account of item.accountData) {
            if (
              account &&
              account.accountName &&
              account.accountName.toLowerCase().includes(q)
            ) {
              $accountData.push(account);
            }
          }
          if ($accountData.length > 0) {
            let data = JSON.parse(JSON.stringify(item));
            data.accountData = $accountData;
            searchData.push(data);
          }
        }
        this.tableData = searchData;
      } else {
        if (this.fixedIndex !== null && this.backupTableData[this.fixedIndex]) {
          this.tableData = [JSON.parse(JSON.stringify(this.backupTableData[this.fixedIndex]))];
        } else {
          this.tableData = JSON.parse(JSON.stringify(this.backupTableData));
        }
      }
    },
    async getProductionData(filterData) {
      this.loading = true;
      try {
        let $obj = {};
        $obj.filterData = filterData ? filterData : null;
        let res = await ProductionDashboardService.liveBoard($obj);
        if (res && res.length > 0) {
          for (let item of res) {
            if (item.accountData) {
              item.accountData.forEach((item1) => {
                item1.accountName =
                  item1 && item1.accountName === null ? "" : item1.accountName;
              });
              item.accountData.sort((a, b) => (a.accountName || '').localeCompare(b.accountName || ''));
              for (let item2 of item.accountData) {
                if (item2.userData) {
                  item2.userData.sort((a, b) => (a.user_name || '').localeCompare(b.user_name || ''));
                }
              }
            }
          }
          this.tableData = res;
        } else {
          this.tableData = [];
        }
        this.backupTableData = JSON.parse(JSON.stringify(this.tableData));
        this.fixedIndex = null;
      } catch (err) {
        console.error("Error fetching Account LiveBoard data:", err);
        this.tableData = [];
        this.backupTableData = [];
      } finally {
        this.loading = false;
      }
    },

    addData(data) {
      this.finalExportData = data;
    },

    async exportFile(type) {
      let sourceData = [];
      let column;
      this.finalExportData.forEach((workspace) => {
        workspace.accountData.forEach((account) => {
          account.work_space_name= workspace.workSpaceName
          sourceData.push(account);
        });
      });

      column = [
        {
          field: "work_space_name",
          header: "WorkSpace",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        },
        // {
        //   field: "user_name",
        //   header: "User",
        //   style: { width: "100px", color: "" },
        //   toolTip: "Name",
        //   sortfield: true,
        // },
        // {
        //   field: "project_name",
        //   header: "Project",
        //   style: { width: "100px", color: "" },
        //   toolTip: "Name",
        //   sortfield: true,
        // },
        {
          field: "accountName",
          header: "Account Name",
          style: { width: "100px", color: "" },
          toolTip: "Account Name",
          sortfield: true,
        },
        
        {
          field: "total_issues",
          header: "Total",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },        
        {
          field: "open_issues",
          header: "Open",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "assigned_issues",
          header: "Assigned",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        
        {
          field: "inprogress_issues",
          header: "Inprogress",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        
        {
          field: "qapending_issues",
          header: "Qa pending",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "clarification_issues",
          header: "Clarification",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "hold_issues",
          header: "Hold",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "it_issues",
          header: "IT",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "pastdue_issues",
          header: "Past Due",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        // {
        //   field: "qacompleted_issues",
        //   header: "Qa completed",
        //   style: { width: "100px", color: "" },
        //   toolTip: "Num",
        //   sortfield: true,
        // },
        {
          field: "completed_issues",
          header: "Completed/Today",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
      ];

      if (this.finalExportData !== this.tableData) {
        column.splice(2, 0, {
          field: "account",
          header: "Account",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        });
      }
      await ExportService.export(sourceData, "Account Live Board", column, type);
    },
  },
};
</script>

<style></style>
